import { render, staticRenderFns } from "./ViewDpaFileComponent.vue?vue&type=template&id=37b8e828&"
import script from "./ViewDpaFileComponent.vue?vue&type=script&lang=js&"
export * from "./ViewDpaFileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports